"use strict";

import {updateDefaultTopPosition} from "./affixNav";

let $notificationHeader;

function updateHeightOffset() {
    let height = ($notificationHeader && $notificationHeader.is(':visible')) ? $notificationHeader.outerHeight() : 0;
    document.documentElement.style.setProperty('--notification-header-height', height + 'px');
}

export function init () {
    $notificationHeader = $('.js-notification-header');
    let notificationName = $notificationHeader.data('notification-header-name') || 'notificationHeader';

    try {
        let data = sessionStorage.getItem(notificationName);
        if (data != 'alreadyShown') {
            $notificationHeader.removeAttr('hidden');
            updateDefaultTopPosition();
        }
    } catch(err) {}

    updateHeightOffset();
    $(window).on('resize', updateHeightOffset);

    $('.js-notification-header__close').on('click', function() {
        try {
            sessionStorage.setItem(notificationName, 'alreadyShown');
            $notificationHeader.attr('hidden', '');
            updateDefaultTopPosition();
            updateHeightOffset();
        } catch(err) {}
    });
}

export function hideNotification() {
    if($notificationHeader) {
        $notificationHeader.css('display', 'none');
        updateHeightOffset();
    }
}
export function showNotification() {
    if($notificationHeader) {
        $notificationHeader.css('display', 'flex');
        updateHeightOffset();
    }
}
